import {IconButton, InputAdornment, TextField, useTheme} from '@mui/material';
import {observer} from 'mobx-react';
import FormFieldBase from './FormFieldBase';
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {useState} from "react";

function FormPasswordField({
                           label = undefined,
                           placeholder = undefined,
                           field,
                           width = '100%',
                           disabled = false,
                           rows = 1
                       }) {
    const [showPassword, setShowPassword] = useState(false);
    const handleShowPasswordToggle = () => setShowPassword((show) => !show);

    const theme = useTheme();
    const style = styles(theme, width);

    return (
        <FormFieldBase>
            <TextField
                type={showPassword ? 'text' : 'password'}
                placeholder={placeholder || label}
                InputLabelProps={{shrink: false}}
                disabled={disabled}
                multiline={rows > 1}
                rows={rows}
                style={style.fieldContainer}
                value={field.value}
                onChange={(e) => {
                    field.updateValue(e.target.value);
                }}
                sx={{
                    '& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root': {
                        fontSize: '.8rem',
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" style={style.iconContainer}>
                            <IconButton
                                onClick={handleShowPasswordToggle}
                                onMouseDown={(e) => e.preventDefault()}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </FormFieldBase>
    );
}

const styles = (theme, width) => ({
    fieldContainer: {
        backgroundColor: theme.brand.field,
        justifyContent: 'center',
        borderRadius: '0.5rem',
        width: width,
    },
    iconContainer: {
        backgroundColor: theme.brand.field,
    }
});

export default observer(FormPasswordField);